import React from "react";
import { useNavigate } from "react-router-dom";

export default function InvoiceCustomerMenuBoard({
  order,
  mobile,
  setEditModal,
  setDeleteModal,
}) {
  const navigate = useNavigate();

  const isVisible = (type) => {
    switch (type) {
      case "Send invoice":
        return true;
      default:
        return false;
    }
  };

  const menu = [
    {
      label: "Edit customer",
      action: () => {
        setEditModal(true);
      },
      visible: true,
    },
    {
      label: "Delete customer",
      action: () => {
        setDeleteModal(true);
      },
      visible: true,
    },
  ];

  return (
    <div
      className={`${
        !mobile ? "absolute right-2 top-full" : ""
      } p-2 flex flex-col z-10 bg-white rounded-md shadow-xl min-w-[200px]`}
    >
      {menu
        ?.filter((item) => item?.visible)
        ?.map((item, index) => (
          <div
            key={index}
            className="w-full cursor-pointer text-sm text-black py-1 px-2 transition-all hover:text-primary1"
            onClick={item.action}
          >
            <span>{item.label}</span>
          </div>
        ))}
    </div>
  );
}
